import { t } from "@/i18n";

import { SIDDET_LABEL_KEY, SIDDET_SECENEKLERI, type Siddet } from "./severity";

interface SiddetFiltreProps {
  value: Siddet | "hepsi";
  onChange: (value: Siddet | "hepsi") => void;
}

/** Bulgular tablosu ustundeki siddet filtresi (sozlesme §2). */
export function SiddetFiltre({ value, onChange }: SiddetFiltreProps) {
  return (
    <label className="flex flex-wrap items-center gap-2 text-sm text-muted">
      {t("denetim.siddet_filtre.etiket")}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as Siddet | "hepsi")}
        className="input w-auto min-w-[140px]"
      >
        <option value="hepsi">{t("denetim.siddet_filtre.hepsi")}</option>
        {SIDDET_SECENEKLERI.map((s) => (
          <option key={s} value={s}>
            {t(SIDDET_LABEL_KEY[s])}
          </option>
        ))}
      </select>
    </label>
  );
}
